import React from 'react';
import './App.css';

const App: React.FC = () => {
    const baseURI = 'https://kramerica-industries.s3-us-west-2.amazonaws.com/';
    const [generatedNumber, setGeneratedNumber] = React.useState<string>('');
    const vidRef = React.useRef(null);

    React.useEffect(() => {
        let preExistingEpisode = window.location.hash.replace('#', '');
        if (preExistingEpisode !== '' && preExistingEpisode !== '0') {
            setGeneratedNumber(preExistingEpisode);
        } else {
            let videoNumber = Math.floor(Math.random() * 177 + 1);
            console.log(videoNumber);
            setGeneratedNumber(videoNumber.toString());
        }
    }, []);

    if (generatedNumber === '') {
        return <div>Loading...</div>;
    } else {
        return (
            <main>
                <h1>A Festivus!</h1>
                <video
                    preload="auto"
                    autoPlay
                    muted
                    playsInline
                    controls
                    className="video-player"
                    ref={vidRef}
                >
                    <source src={`${baseURI}${generatedNumber}.mp4`} />
                </video>
                <p className="actions">
                    <a href={'#' + generatedNumber}>Bookmark Episode</a>
                    <span className="separator">|</span>
                    <button
                        className="link-button"
                        onClick={() => {
                            window.location.href = 'https://festivus.mom/';
                        }}
                    >
                        Refresh
                    </button>
                </p>
            </main>
        );
    }
};

export default App;
